import React from 'react';
import styled, { css } from 'styled-components';

import { CategoriesMobileDisplayOption, RadiusOption } from 'types/graphql';
import { ListProps } from './list.types';
import { CategoriesList } from './categories-list';

const radiusOptions = {
  [RadiusOption.rounded]: '9999px',
  [RadiusOption.roundedRectangle]: '12px',
  [RadiusOption.square]: 0,
};

export const TextList = ({ items, mobileDisplay, style, showHeading = true }: ListProps): JSX.Element => (
  <CategoriesList
    mobileDisplay={mobileDisplay}
    itemCount={items.length}
    showViewAll={false}
    gap={8}
    showHeading={showHeading}
  >
    {items.map(({ category }) => (
      <ListItem key={category} $radius={style} $mobileDisplay={mobileDisplay}>
        {category}
      </ListItem>
    ))}
  </CategoriesList>
);

const ListItem = styled.li<{
  $radius: RadiusOption;
  $mobileDisplay: CategoriesMobileDisplayOption;
}>`
  background: #fff;
  border: 2px solid #e3e7e9;
  border-radius: ${({ $radius }) => radiusOptions[$radius]};
  color: #121516;
  font-size: 16px;
  font-weight: 600;
  line-height: ${24 / 16};
  padding: 10px 14px;
  text-align: center;
  white-space: nowrap;

  ${({ $mobileDisplay }) =>
    $mobileDisplay === CategoriesMobileDisplayOption.grid &&
    css`
      width: calc(50% - 4px);
    `}
`;
